const KeenSlider = window.KeenSlider

const { useAutoplay } = window.BAO.Carousel.plugins

class FooterStraplines extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (!this?.els?.slides?.exists) return

    if (!this?.els?.slide?.exists) return

    if (this.els.slide.elements.length < 2) return

    this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slideChanged: this.onSlideChanged,
      },
      [useAutoplay(6, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    const currentSlide = instance.track.details.rel

    this.els.slide.elements.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('footer-straplines')) {
  customElements.define('footer-straplines', FooterStraplines)
}
